import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Onemogucava pregledacu da sam vraca skrol (bitno za produkciju)
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    // Forsira trenutni skok na vrh bez obzira na CSS smooth scroll
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' // Pokusava instant skok ako browser podrzava
    });

    // Rezervni plan: direktno resetovanje ako behavior 'instant' nije podrzan
    if (window.scrollY !== 0) {
        window.scrollTo(0, 0);
    }
    
  }, [pathname]);

  return null;
}

export default ScrollToTop;
